import * as React from "react";
const SvgView = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke="#2D2D2D"
      strokeWidth={1.111}
      d="M14.75 4.773C13.045 2.097 10.553.556 7.928.556c-1.312 0-2.588.383-3.753 1.098-1.165.723-2.212 1.777-3.067 3.12C.37 5.93.37 7.81 1.109 8.968c1.703 2.683 4.195 4.217 6.82 4.217 1.312 0 2.588-.383 3.753-1.099 1.165-.722 2.212-1.777 3.067-3.118.738-1.15.738-3.038 0-4.196Zm-6.821 5.08A2.975 2.975 0 0 1 4.95 6.874 2.975 2.975 0 0 1 7.93 3.896a2.975 2.975 0 0 1 2.979 2.978 2.975 2.975 0 0 1-2.979 2.98Z"
    />
  </svg>
);
export default SvgView;
